import Tooltip from 'components/@extended/Tooltip';
import { CircleAlert as CircleAlertIcon } from 'components/icons';
import { FOCUS_RING } from 'layout/NewDesignLayout/focusRing';
import { useId } from 'react';
import { InvoiceTimecardIssueType } from 'types/invoice-details';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

const ISSUE_MESSAGE: Record<InvoiceTimecardIssueType, string> = {
    [InvoiceTimecardIssueType.MISSING_JOB_ROLE]: 'invoices.details.table.timecard-issue-missing-job-role',
    [InvoiceTimecardIssueType.MISSING_HOURLY_RATE]: 'invoices.details.table.timecard-issue-missing-hourly-rate',
};

/** The message ids of a timecard's issues, for a row that writes them out under its entry. */
export const getTimecardIssueMessages = (issues: InvoiceTimecardIssueType[] | undefined) =>
    (issues ?? []).map((issue) => ISSUE_MESSAGE[issue]).filter(Boolean);

type Props = {
    issues: InvoiceTimecardIssueType[] | undefined;
};

export const TimecardIssueIndicator = ({ issues }: Props) => {
    const descriptionId = useId();
    const messages = getTimecardIssueMessages(issues);
    if (messages.length === 0) return null;

    return (
        <>
            <Tooltip text={messages} className="text-left">
                <span
                    tabIndex={0}
                    aria-describedby={descriptionId}
                    className={cn('text-fg-warning flex shrink-0 items-center rounded-full', FOCUS_RING)}
                >
                    <CircleAlertIcon className="size-4" />
                </span>
            </Tooltip>
            <span id={descriptionId} hidden>
                {messages.map((message) => t(message)).join('. ')}
            </span>
        </>
    );
};
